// extracted by mini-css-extract-plugin
module.exports = {"main":"Table_main__3wPDr","title":"Table_title__394hs","link":"Table_link__37Znz"};